import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { TmMitigation } from '../../models/tmMitigation.ts';

interface TmMitigationState {
  tmMitigations: TmMitigation[];
  selectedTmMitigation: TmMitigation | null;
}

const initialState: TmMitigationState = {
  tmMitigations: [],
  selectedTmMitigation: null,
};

const tmMitigationSlice = createSlice({
  name: 'tmMitigation',
  initialState,
  reducers: {
    setTmMitigations(state, action: PayloadAction<TmMitigation[]>) {
      state.tmMitigations = action.payload;
    },
    addTmMitigation(state, action: PayloadAction<TmMitigation>) {
      state.tmMitigations.push(action.payload);
    },
    updateTmMitigation(state, action: PayloadAction<TmMitigation>) {
      const index = state.tmMitigations.findIndex((m: TmMitigation) => m.id === action.payload.id);
      if (index !== -1) state.tmMitigations[index] = action.payload;
    },
    removeTmMitigation(state, action: PayloadAction<number>) {
      state.tmMitigations = state.tmMitigations.filter((m: TmMitigation) => m.id !== action.payload);
    },
    setSelectedTmMitigation(state, action: PayloadAction<TmMitigation | null>) {
      state.selectedTmMitigation = action.payload;
    },
  },
});

export const { setTmMitigations, addTmMitigation, updateTmMitigation, removeTmMitigation, setSelectedTmMitigation } = tmMitigationSlice.actions;
export const selectTmMitigations = (state: RootState) => state.tmMitigation.tmMitigations;
export const selectSelectedTmMitigation = (state: RootState) => state.tmMitigation.selectedTmMitigation;
export default tmMitigationSlice.reducer;

